import React from "react";
import "./services.css";
import { BiCheck } from "react-icons/bi";

const Services = () => {
  return (
    <section id="services">
      <h5>What I Offer ?</h5>
      <h2>Services</h2>

      <div className="container services__container">
        {/* AI & Machine Learning */}
        <article className="service">
          <div className="service__header">
            <h3>AI & Machine Learning</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>
                Custom machine learning model development (classification,
                regression, clustering)
              </p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>
                Computer vision applications (object detection, image
                recognition, facial recognition)
              </p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>
                Natural Language Processing (NLP) solutions (text analysis,
                sentiment analysis, chatbots)
              </p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Deep learning model implementation with TensorFlow/Keras</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>
                LLM integration and prompt engineering for business applications
              </p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Model deployment and API development with FastAPI</p>
            </li>
          </ul>
        </article>

        {/* Data Science & Analytics */}
        <article className="service">
          <div className="service__header">
            <h3>Data Science & Analytics</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>End-to-end data analysis and visualization</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Data cleaning and preprocessing pipelines</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Feature engineering and data transformation</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>SQL database design and optimization (SQL Server, MongoDB)</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Web scraping and data extraction from websites</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Interactive dashboards and data apps with Streamlit</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Business intelligence reporting and insights</p>
            </li>
          </ul>
        </article>

        {/*Web Development & Design */}
        <article className="service">
          <div className="service__header">
            <h3>Web Development & Design</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Full-stack web application development</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Responsive and interactive user interfaces</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Backend API development with FastAPI</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Modern frontend development with React.js</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Database integration (MongoDB, SQL)</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Git/GitHub version control and collaboration</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Graphic design for web and digital content</p>
            </li>
          </ul>
        </article>
      </div>
    </section>
  );
};

export default Services;
